/**
 * product-sticky-granel.js
 * Calcula el top dinámico de la imagen sticky en la página de producto.
 * Suma la altura de todos los elementos fixed/sticky que hay encima:
 * announcement bar + header + nav de categorías.
 * Solo activo en desktop (≥750px).
 */
(function () {
  if (window.innerWidth < 750) return;

  const media = document.querySelector('.product-information__media');
  if (!media) return;

  function calcTop() {
    if (window.innerWidth < 750) {
      media.style.top = '';
      return;
    }

    // Busca todos los elementos sticky/fixed que estén en la parte superior
    let totalHeight = 0;
    const candidates = document.querySelectorAll(
      'sticky-header, .header-wrapper, .announcement-bar, .pnav, [class*="announcement"], [id*="announcement"]'
    );

    candidates.forEach(el => {
      const s = window.getComputedStyle(el);
      if (s.position === 'sticky' || s.position === 'fixed') {
        const rect = el.getBoundingClientRect();
        // Solo contar elementos que están en la parte superior del viewport
        if (rect.top <= 4 && rect.height > 0) {
          totalHeight = Math.max(totalHeight, rect.bottom);
        }
      }
    });

    // Si no encontró nada, medir empíricamente el espacio libre en el top
    if (totalHeight === 0) {
      // Fallback: usar el .pnav si existe, o 0
      const pnav = document.querySelector('.pnav');
      if (pnav) {
        const ps = window.getComputedStyle(pnav);
        if (ps.position === 'sticky') {
          totalHeight = pnav.getBoundingClientRect().height;
        }
      }
    }

    const offset = totalHeight + 16; // 16px de aire
    media.style.top = offset + 'px';
  }

  // Calcular al cargar
  calcTop();

  // Recalcular en resize
  window.addEventListener('resize', calcTop, { passive: true });

  // Recalcular al scrollear (el nav puede colapsar)
  window.addEventListener('scroll', calcTop, { passive: true });
})();
